<template>
    <div class="crud-wrapper">
        <crud-toolbar :modalMode="modalMode" :newState="newState" :showBack="false" :title="modalTitle"
                      @onCommand="toolbarCommand"></crud-toolbar>

        <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

            <v-layout row wrap>
                <v-flex column xs12>
                    <label class="v-label v-label--active theme--light aLabel">Cliente</label>
                    <label class="title font-weight-bold grey--text">{{this.refData.clientName}}</label>
                </v-flex>

                <v-flex xs6>
                    <label class="v-label v-label--active theme--light aLabel">Valor do Cheque</label>
                    <label class="pl-5 title font-weight-bold grey--text">{{this.refData.check_amount | fmtMoney}}</label>
                </v-flex>

                <v-flex xs6>
                    <label class="v-label v-label--active theme--light aLabel">Débito</label>
                    <label class="pl-5 title font-weight-bold grey--text">{{this.refData.balance_due | fmtMoney}}</label>
                </v-flex>

                <v-flex pa-0 xs6>
                    <a-number-field autofocus class="large-input" id="test" label="Valor da Taxa" number-mask="us"
                                    v-model="formData.amount" validate="gtZero"></a-number-field>
                </v-flex>

                <v-flex pa-0 xs6>
                    <a-date-field :min="$util.dateRange.today.start('YYYY-MM-DD')" label="Adiar Depósito"
                                  v-model="formData.new_cash_at"
                                  validate="required, dateMDY"></a-date-field>
                </v-flex>

            </v-layout>

        </crud-form>

    </div>
</template>

<script>
   import numeral from 'numeral';
   import CrudFormClass from "@consigmais-team/vue-common/layout/crudPage/crudFormClass";

   export default CrudFormClass.extend({

      name: 'ExtraFee',

      data() {
         return {
            title: 'Valor de taxa extra',
            formName: 'extraFeeForm',

            formData: {
               id: null,
               companyId: this.$store.state.company.selectedStore,
               done_at: null,
               typeId: 4,
               clientId: null,
               exchangeId: null,
               amount: 0,
               notes: null,
               cash_at: null,
               new_cash_at: null,
               selectedCheck: null,
               selectedBalance: 0
            }
         }
      },

      computed: {
         fromExchanges() {
            return Boolean(this.refData);
         }
      },

      methods: {
         saveConfirmation() {
            return new Promise((resolve, reject) => {
               this.$msg.confirm({
                  title: 'Confirma?',
                  message: `Taxa extra de ${this.formData.amount} será lançada para o cliente.`,
                  actions: ['Sim', 'Não'],
                  defaultAction: 0
               }).then((action) => (action === 0) ? resolve(true) : reject(false));
            });

         }

      },

      mounted() {
         if (this.refData) {
            this.formData.companyId = this.$store.state.company.selectedStore || this.refData.companyId;
            this.formData.clientId = this.refData.clientId;
            this.formData.exchangeId = this.refData.id;
            this.formData.selectedBalance = this.refData.balance_due;
            this.formData.cash_at = this.refData.cash_at;
            this.formData.new_cash_at = this.refData.cash_at;
         }
      }


   })

</script>

<style scoped>


</style>








// WEBPACK FOOTER //
// src/pages/ExtraFee.vue